import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import classNames from 'classnames';
import {connectToStores} from 'epic-alt-utils/index';
import {EpicGamesNavWrapper, EpicGamesFooterWrapper} from './components';
import MetaTags from './components/common/MetaTags';
import getRoutes from './routes/routes';
import {FooterStore, LoginStore, LocalizationStore, AppConfigStore, HeaderStore} from './stores';
import AppConfigActions from './actions/AppConfigActions';

@connectToStores
class App extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        history: PropTypes.object,
        localizationStore: PropTypes.object,
        loginStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        headerStore: PropTypes.object,
        footerStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        msie: PropTypes.bool
    };

    static getStores() {
        return [LoginStore, LocalizationStore, AppConfigStore, HeaderStore, FooterStore];
    }

    static getPropsFromStores() {
        return {
            loginStore: LoginStore.getState(),
            localizationStore: LocalizationStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            footerStore: FooterStore.getState(),
            headerStore: HeaderStore.getState(),
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet(),
            msie: HeaderStore.getState().msie()
        };
    }

    static getInitialActions() {
        return [
            () => {
                AppConfigActions.fetchEpicSid()
            }
        ];
    }

    render() {
        const classes = classNames('battleBreakers-wrapper', {
            mobile: this.props.mobile,
            tablet: this.props.tablet,
            msie: this.props.msie
        });
        const {defaultMetaData} = this.props.appConfigStore;
        const {location} = this.props;
        const isMotd = location.pathname.match(/.*\/motd/);
        const routes = getRoutes();
        const appClass = classNames({motd: isMotd});
        return (
            <div className={appClass}>
                <MetaTags
                    meta={defaultMetaData}
                    title={this.props.localizationStore.messages['epic.battlebreakers.name']} />
                {isMotd ? null : (
                    <EpicGamesNavWrapper
                        location={this.props.location}
                        loginStore={this.props.loginStore}
                        headerStore={this.props.headerStore}
                        localizationStore={this.props.localizationStore}
                        appConfigStore={this.props.appConfigStore}
                        history={this.props.history}
                        mobile={this.props.mobile}
                        tablet={this.props.tablet} />
                )}
                <div className={classes}>
                    {routes}
                </div>
                {isMotd ? null : (
                    <EpicGamesFooterWrapper
                        loginStore={this.props.loginStore}
                        footerStore={this.props.footerStore}
                        localizationStore={this.props.localizationStore} />
                )}
            </div>
        );
    }
}

export default withRouter(App);

